export default class LayoutUtil {
    deselectAll(layout) {
        for(let i = 0; i < layout.rows.length; i++) {
            let currentRow = layout.rows[i]
            currentRow.selected = false

            for(let j = 0; j < currentRow.columns.length; j++) {
                let currentColumn = currentRow.columns[j]
                currentColumn.selected = false

                for(let k = 0; k < currentColumn.value.length; k++) {
                    currentColumn.value[k].selected = false
                }
            }
        }
    }

    deslectRows(layout) {
        for (let i = 0; i < layout.rows.length; i++) {
            layout.rows[i].selected = false
        }
    }

    deselectColumns(layout)  {
        for(let i = 0; i < layout.rows.length; i++) {

            let currentRow = layout.rows[i]

            for(let j = 0; j < currentRow.columns.length; j++) {
                currentRow.columns[j].selected = false
            }
        }
    }

    getFormComponents(layout) {
        let formComponents = []

        for(let i = 0; i < layout.rows.length; i++) {
            let currentRow = layout.rows[i]

            for(let j = 0; j < currentRow.columns.length; j++) {
                let currentColumn = currentRow.columns[j]

                for(let k = 0; k < currentColumn.value.length; k++) {
                    let currentComponent = currentColumn.value[k]

                    if( currentComponent.type === 'Field' ) {
                        formComponents.push(currentComponent)
                    }

                }
            }
        }

        return formComponents
    }

    initConditions(layout) {
        for(let i = 0; i < layout.rows.length; i++) {

            let currentRow = layout.rows[i]

            if(!currentRow.conditions) {
                currentRow.conditions = []
            }
        }
    }

    deselectComponents(layout)  {
        for(let i = 0; i < layout.rows.length; i++) {
            let currentRow = layout.rows[i]

            for(let j = 0; j < currentRow.columns.length; j++) {
                let currentColumn = currentRow.columns[j]

                for(let k = 0; k < currentColumn.value.length; k++) {
                    currentColumn.value[k].selected = false
                }
            }
        }
    }

    setColumnWidths(currentColumn, columns) {
        currentColumn.widthSet = true
        let widthSetColumns = columns.filter(column => column.widthSet)
        let setWidths = 0

        for(let i = 0; i < widthSetColumns.length; i++) {
            setWidths += Number(widthSetColumns[i].width)
        }

        let defaultColumns = columns.filter(column => !column.widthSet)
        let newWidth = (12 - setWidths) / defaultColumns.length
        newWidth = Math.round(newWidth)
        for (let i = 0; i < defaultColumns.length; i++) {
            // last item, assign remaining width
            if(i === defaultColumns.length - 1) {
                newWidth = 12 - setWidths
            }
            else {
                setWidths += newWidth
            }

            let column = defaultColumns[i]
            column.width = newWidth.toString().replace('.', '-')
        }
    }
}